/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Modal as ModalAD } from 'antd';
import './Modal.scss';

function Modal(props) {
  return <ModalAD className="modal" {...props} />;
}

export default Modal;
